import {
  frontend,
  backend,
  reactjs,
  html,
  css,
  typescript,
  javascript,
  nodejs,
  python,
  java,
  django,
  redux,
  git,
  dxc,
  truework,
  voltaiq,
  wordsnake,
  audioPlayer,
  triviaClash,
  ctct,
  puremagikpics,
} from '../assets';

export const navLinks = [
  {
    id: 'about',
    title: 'Overview',
  },
  {
    id: 'work',
    title: 'Experience',
  },
  {
    id: 'personal',
    title: 'About',
  },
];

const services = [
  {
    title: 'Frontend Developer',
    icon: frontend,
  },
  {
    title: 'Backend Developer',
    icon: backend,
  },
];

const technologies = [
  {
    name: 'HTML 5',
    icon: html,
  },
  {
    name: 'CSS 3',
    icon: css,
  },
  {
    name: 'JavaScript',
    icon: javascript,
  },
  {
    name: 'TypeScript',
    icon: typescript,
  },
  {
    name: 'React JS',
    icon: reactjs,
  },
  {
    name: 'Python',
    icon: python,
  },
  {
    name: 'Java',
    icon: java,
  },
  {
    name: 'Django',
    icon: django,
  },
  {
    name: 'Redux Toolkit',
    icon: redux,
  },
  {
    name: 'Node JS',
    icon: nodejs,
  },
  {
    name: 'Git',
    icon: git,
  },
];

const experiences = [
  {
    title: 'Software Engineer II',
    company_name: 'Constant Contact',
    icon: ctct,
    iconBg: '#ffffff',
    date: 'Aug 2025 - Aug 2026',
  },
  {
    title: 'Software Engineer II',
    company_name: 'Truework',
    icon: truework,
    iconBg: '#ffffff',
    date: 'Sept 2022 - Mar 2024',
  },
  {
    title: 'Software Engineer',
    company_name: 'Voltaiq',
    icon: voltaiq,
    iconBg: '#333333',
    date: 'April 2021 - July 2022',
  },
  {
    title: 'Associate Software Engineer',
    company_name: 'DXC Technology',
    icon: dxc,
    iconBg: '#ffffff',
    date: 'July 2017 - March 2021',
  },
];

const projects = [
  {
    id: 'pure-magik-pics',
    name: 'Pure Magik Pics',
    image: puremagikpics,
    demo: 'https://puremagikpics.com',
  },
  {
    id: 'trivia-clash',
    name: 'Trivia Clash',
    description:
      'Created an online, cross platform, multiplayer trivia game for iOS and Android',
    tags: [{ name: 'React.js', color: 'blue-text-gradient' }],
    image: triviaClash,
    demo: 'https://www.abbazzi.com/apps/triviaclash/',
  },
  {
    id: 'project-1',
    name: 'Audio Player',
    description:
      'Created an audio player and visualizer to familiar myself with how Web Audio API audio-processing',
    tags: [{ name: 'React.js', color: 'blue-text-gradient' }],
    image: audioPlayer,
    repo: 'https://github.com/JohnCS94/audio-player',
    demo: 'https://audio-player-seven-smoky.vercel.app/',
  },
  {
    id: 'project-2',
    name: 'WordSnake',
    description: 'A mobile cross over between snake and scrabble.',
    tags: [
      {
        name: 'Android Studio',
        color: 'blue-text-gradient',
      },
      {
        name: 'C#',
        color: 'green-text-gradient',
      },
    ],
    image: wordsnake,
    repo: 'https://github.com/JohnCS94/Word-Snake',
  },
];

export { services, technologies, experiences, projects };
